import { Component } from '@angular/core'

import { TranslateModule } from '@ngx-translate/core'
import { VERSION } from '@angular/material/core'

@Component({
    selector: 'app-footer',
    imports: [TranslateModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  isNextVersion = location.hostname === 'next.material.angular.io';
  version = VERSION.full;
  year = new Date().getFullYear();
}
